import { useState } from 'react';
import { Mail, X, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function EmailVerificationBanner() {
  const { user, token, updateUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Hide if user verified, dismissed locally, or no user
  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    if (sending) return;
    setSending(true);
    try {
      const { data } = await axios.post(
        `${API_BASE}/api/auth/resend-verification`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (data?.sent) {
        toast.success('Link de confirmação enviado!', {
          description: `Verifique sua caixa em ${user.email}`,
        });
      } else {
        // O backend respondeu que o e-mail JA esta verificado (sent: false).
        // O objeto `user` no front estava desatualizado — sincroniza o estado
        // para o banner sumir na hora, em vez de continuar pedindo confirmacao.
        updateUser({ email_verified: true });
        toast.info(data?.message || 'E-mail já confirmado');
      }
    } catch (err) {
      const detail = err.response?.data?.detail || 'Não foi possível reenviar agora. Tente em instantes.';
      toast.error(detail);
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="bg-amber-500/10 border-b border-amber-500/30 px-4 py-2.5 flex items-center justify-between gap-3 text-sm"
      data-testid="email-verification-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Mail className="h-4 w-4 text-amber-500 flex-shrink-0" />
        <span className="text-amber-900 dark:text-amber-200 truncate">
          <strong>Confirme seu e-mail.</strong>{' '}
          <span className="hidden sm:inline">Enviamos um link de confirmação para </span>
          <span className="font-medium">{user.email}</span>.
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={handleResend}
          disabled={sending}
          className="text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 font-medium underline disabled:opacity-50 flex items-center gap-1"
          data-testid="email-verification-resend-btn"
        >
          {sending ? <Loader2 className="h-3 w-3 animate-spin" /> : null}
          {sending ? 'Enviando...' : 'Reenviar link'}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 p-1"
          aria-label="Fechar"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
